import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *项目状态
 * @param params
 * 
*/

export const status = params => Http.get(`${baseUrl}/sz/team/status`, { params } )

/**
 *修改项目状态
 * @param params
 * 
*/

export const editStatus = params => Http.post(`${baseUrl}/sz/team/status`, params )


/**
 *评分列表
 * @param params
 * 
*/

export const scoreList = params => Http.get(`${baseUrl}/sz/team/${params.category}`, { params })

/**
 *新增评价项目
 * @param params
 * 
*/

export const addItem = params => Http.post(`${baseUrl}/sz/team/${params.category}/item`, params )

/**
 *修改评价项目
 * @param params
 * 
*/

export const editItem = params => Http.put(`${baseUrl}/sz/team/${params.category}/item`, params )

/**
 *删除评价项目
 * 
*/

export const delItem = (category, ids) => Http.delete(`${baseUrl}/sz/team/${category}/item/${ids}` )

/**
 *重置评价项目列表
 * @param category
 * @param classId
 * 
*/

export const resetList = (category, classId) => Http.post(`${baseUrl}/sz/team/${category}/item/${classId}/reset`)

/**
 *评价项目列表
 * @param params
 * 
*/

export const itemList = params => Http.get(`${baseUrl}/sz/team/${params.category}/item`, { params })

/**
 *评价项目排序
 * @param params
 * 
*/

export const sort = params => Http.put(`${baseUrl}/sz/team/${params.category}/item/sort`,  params.ids )

/**
 *评价项目类型列表
 * @param params
 * 
*/

export const itemTypeList = params => Http.get(`${baseUrl}/sz/team/${params.category}/item/types`, { params })

/**
 *评价详情
 * @param category
 * @param teamId
 * 
*/

export const evaluateInfo = (category, teamId) => Http.get(`${baseUrl}/sz/team/${category}/${teamId}/score`)

/**
 *提交评分
 * @param params
 * 
*/

export const doEvaluate = params => Http.post(`${baseUrl}/sz/team/${params.category}/${params.teamId}/score`, params )

/**
 *团队排行
 * @param category
 * @param classId
 * 
*/

export const teamRanking = (category, classId) => Http.get(`${baseUrl}/sz/team/${category}/${classId}/top`)

/**
 *结算成绩
 * @param category
 * @param classId
 * 
*/

export const settle = (category, classId) => Http.post(`${baseUrl}/sz/team/${category}/${classId}/complete`)
